<template functional>
  <transition
    mode="out-in"
    enter-active-class="anim-turnup"
    leave-active-class="anim-slide-top-small anim-fast anim-reverse"
  >

    <!-- asc order -->
    <span
      v-if="$options.sam(props) && props.sort.order === 'ASC'"
      key="asc"
      class="icon"
    >
      <decor-icon icon="sort-alpha-up"></decor-icon>
    </span>

    <span
      v-else-if="$options.sam(props) && props.sort.order === 'DESC'"
      key="desc"
      class="icon"
    >
      <decor-icon icon="sort-alpha-down"></decor-icon>
    </span>

    <span
      v-else-if="props.column.sortable"
      key="desc"
      class="icon dataset-th-icon-hidden"
    >
      <decor-icon icon="sort"></decor-icon>
    </span>

  </transition>
</template>

<script>
export default {
  name: 'DatasetOrderIcon',
  props: {
    column: { type: Object, default: () => ({}) },
    sort: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: () => true },
  },
  sam: props => {
    const compare = props.sort.field === props.column.key
    return compare
  },
}
</script>


<style lang="scss">
.dataset-th-icon-hidden {
  opacity: 0;
  visibility: hidden;
}
</style>
